// Simple EN/TR translations for the Profinoks clone.
// This is frontend-only and can later be wired to CMS data.

export const LANGUAGES = {
  EN: "en",
  TR: "tr",
};

export const translations = {
  en: {
    hero: {
      badge: "Profinoks Industrial Kitchen Equipment",
      subtitle:
        "Reliable designer and manufacturer of hotel equipment and movable furniture for the hospitality industry.",
    },
    nav: {
      home: "Home Page",
      corporate: "Corporate",
      products: "Products",
      references: "References",
      projects: "Projects",
      news: "News",
      contact: "Contact",
      catalogue: "Product Catalogue",
      admin: "Admin",
    },
    productGroups: {
      heading: "OUR PRODUCTS",
      animation: "Animation",
    },
    references: {
      heading: "REFERENCES",
      tagline: "Thank you for adding value",
    },
    testimonials: {
      heading: "CUSTOMER REVIEWS",
      readMore: "Read full story",
    },
    admin: {
      loginTitle: "Admin Panel Login",
      loginDescription: "Enter your credentials to access the admin panel.",
      usernameLabel: "Username",
      passwordLabel: "Password",
      signInButton: "Sign In",
      wrongPassword: "Invalid username or password",
      productsHeading: "Products CMS",
      newProduct: "New Product",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
    },
    search: {
      results: "Search Results",
      noResults: "No results found for",
      placeholder: "Search Product",
      itemsFound: "items found",
      backToProducts: "Back to Products",
      emptyState: "Try searching for something else or browse our categories.",
    },
    common: {
      view: "View",
      details: "Details",
      explore: "Explore",
      readMore: "Read More",
      back: "Back",
      sku: "SKU",
      noImage: "No Image",
    },
    projects: {
      heading: "OUR PROJECTS",
      subheading: "Our turnkey industrial kitchen projects brought to life with advanced engineering, superior craftsmanship, and contemporary design.",
    },
    legal: {
      privacyTitle: "Privacy and Personal Data Protection Policy",
      termsTitle: "Terms of Service and Legal Notice",
      lastUpdate: "Last Update",
    },
    footer: {
      aboutTitle: "ABOUT PROFINOKS",
      aboutText: "Since 2010, we have been providing services in the production and installation of industrial kitchen equipment. We are one of the leading companies in the sector with our quality production approach and customer satisfaction-oriented working principle.",
      linksTitle: "QUICK LINKS",
      contactTitle: "CONTACT INFO",
      hoursTitle: "WORKING HOURS",
      copyright: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
    },
    corporate: {
      aboutTitle: "ABOUT US",
      aboutText1: "Established in 2010 in the industrial kitchen equipment sector, Profinoks Kitchen has achieved significant success in its sector in a short time with its high quality standards, past experiences, product range, and project completion processes.",
      aboutText2: "Based on customer satisfaction in all our works, in addition to being a lean industrial kitchen company, we also provide consultancy services on the products and projects our customers need, providing product and project coordination. We establish our quality standards in advance in the products we produce and the projects we complete, and we continue this quality understanding without compromise until the conclusion.",
      aboutText3: "According to us, quality expresses the proven correctness of the work to be done. In other words, it is the most important life element that people should handle multidimensionally, primarily health and life safety. Quality should not be perceived only as product quality. To us, quality is a standard and should take place in every area of life.",
      aboutText4: "For this reason, Profinoks Kitchen offers the products its customers need with high variety and quality standards.",
      aboutText5: "Our company, operating in the kitchen sector, will continue its work by providing all kinds of infrastructure formation to keep the quality awareness alive for its employees and customers within the framework of operation, order, and system with your participation.",
      missionTitle: "MISSION & VISION",
      missionSub: "OUR MISSION",
      missionText: "As PROFINOKS KITCHEN, our mission is to continue producing projects with high standards and a quality-oriented service understanding in the sector we operate in. In this direction, our goal is to fulfill our responsibilities towards the environment and universal values, and to progress by growing towards our goals together with the developing Turkey.",
      visionSub: "OUR VISION",
      visionText: "Since our establishment, our company has been shaped on the slogan of 'Superior Service, Definitive Solution and Trust'. The meaning of this vision for us is to deserve the trust placed in us in the market every day with the products and services we offer and to carry it to further levels by ensuring customer satisfaction.",
      qualityTitle: "OUR QUALITY POLICY",
      qualitySubtitle: "Our quality policy;",
      qualityIntro: "As Profinoks Kitchen, our most important product is QUALITY. Quality gains meaning when it is a sustainable and improvable service. Our company will continue to offer solution-oriented projects with sustainable quality standards.",
      qualityItems: [
        "QUALITY is the culture of our company. We will continuously develop it.",
        "We will prepare customer requests as best as possible and in the shortest time possible.",
        "Our goal is not only to solve the problems we encounter in line with our targets, but also to investigate the source of the problem and prevent its recurrence.",
        "By organizing training programs for our employees, we will realize development as a primary condition at all stages.",
        "We will always provide you with what is right with the kitchen equipment and accessory varieties we have manufactured in accordance with international standards."
      ]
    },
    contact: {
      heading: "CONTACT",
      infoHeading: "CONTACT INFORMATION",
      formHeading: "CONTACT US",
      address: "ADDRESS",
      phone: "PHONE",
      email: "EMAIL",
      hours: "WORKING HOURS",
      nameLabel: "NAME",
      emailLabel: "EMAIL",
      subjectLabel: "SUBJECT",
      messageLabel: "MESSAGE",
      sendButton: "SEND MESSAGE",
      sending: "SENDING...",
      successMsg: "Your message has been sent successfully!",
      errorMsg: "An error occurred. Please try again later.",
    },
  },
  tr: {
    hero: {
      badge: "PROFİNOKS ENDÜSTRİYEL MUTFAK EKİPMANLARI",
      subtitle:
        "Otel ekipmanları ve hareketli mobilyaların güvenilir tasarımcısı ve üreticisi.",
    },
    nav: {
      home: "Ana Sayfa",
      corporate: "Kurumsal",
      products: "Ürünler",
      references: "Referanslar",
      projects: "Projeler",
      news: "Haberler",
      contact: "İletişim",
      catalogue: "Ürün Kataloğu",
      admin: "Yönetim",
    },
    productGroups: {
      heading: "ÜRÜNLERİMİZ",
      animation: "Animasyon",
    },
    references: {
      heading: "REFERANSLAR",
      tagline: "Değer kattığınız için teşekkür ederiz",
    },
    testimonials: {
      heading: "MÜŞTERİ YORUMLARI",
      readMore: "Tüm hikayeyi oku",
    },
    admin: {
      loginTitle: "Yönetici Paneli Girişi",
      loginDescription: "Yönetici paneline erişmek için bilgilerinizi girin.",
      usernameLabel: "Kullanıcı Adı",
      passwordLabel: "Şifre",
      signInButton: "Giriş Yap",
      wrongPassword: "Hatalı kullanıcı adı veya şifre",
      productsHeading: "Ürün CMS",
      newProduct: "Yeni Ürün",
      save: "Kaydet",
      cancel: "Vazgeç",
      delete: "Sil",
    },
    search: {
      results: "Arama Sonuçları",
      noResults: "İçin sonuç bulunamadı",
      placeholder: "Ürün Ara",
      itemsFound: "ürün bulundu",
      backToProducts: "Ürünlere Dön",
      emptyState: "Başka bir terim aramayı deneyin veya kategorilerimize göz atın.",
    },
    common: {
      view: "Görüntüle",
      details: "Detaylar",
      explore: "İncele",
      readMore: "Daha Fazla",
      back: "Geri",
      sku: "SKU",
      noImage: "Resim Yok",
    },
    projects: {
      heading: "PROJELERİMİZ",
      subheading: "Yüksek mühendislik, üstün işçilik ve yenilikçi çözümlerle hayata geçirdiğimiz anahtar teslim endüstriyel mutfak ve gastronomi projelerimiz.",
    },
    legal: {
      privacyTitle: "Gizlilik ve Kişisel Verilerin Korunması Politikası",
      termsTitle: "Hizmet Şartları ve Yasal Uyarı",
      lastUpdate: "Son Güncelleme",
    },
    footer: {
      aboutTitle: "PROFİNOKS HAKKINDA",
      aboutText: "2010 yılından beri endüstriyel mutfak ekipmanları üretimi ve montajı konusunda hizmet vermekteyiz. Kaliteli üretim anlayışımız ve müşteri memnuniyeti odaklı çalışma prensibimizle sektörde öncü firmalardan biriyiz.",
      linksTitle: "HIZLI BAĞLANTILAR",
      contactTitle: "İLETİŞİM BİLGİLERİ",
      hoursTitle: "ÇALIŞMA SAATLERİ",
      copyright: "Tüm hakları saklıdır.",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Koşulları",
    },
    corporate: {
      aboutTitle: "HAKKIMIZDA",
      aboutText1: "Endüstriyel mutfak ekipmanları sektöründe 2010 yılında kurulan Profinoks Mutfak, yüksek kalite standartları, geçmiş tecrübeleri, ürün çeşitliliği ve proje tamamlama süreçleri ile kısa sürede sektöründe önemli başarılara imza atmıştır.",
      aboutText2: "Yaptığımız tüm işlerde müşteri memnuniyetini esas alarak yalın bir endüstriyel mutfak firması olmanın dışında müşterilerimize ihtiyaç duydukları ürün ve proje üzerine danışmanlık hizmetleri de vererek ürün ve proje koordinasyonu sağlamaktayız. Ürettiğimiz ürün ve tamamladığımız projelerde kalite standartlarımızı önceden oluşturur, sonuca ulaşıncaya kadar bu kalite anlayışından taviz vermeden devam ettiririz.",
      aboutText3: "Bize göre kalite yapılacak işin kanıtsanmış doğruluğunu ifade eder. Başka bir ifade ile başta sağlık ve can güvenliği olmak suretiyle insanların çok yönlü olarak ele alması gereken en önemli yaşam unsurudur. Kaliteden kasıt sadece ürün kalitesi olarak algılanmamalıdır. Bize göre kalite bir standarttır ve hayatın her alanında yer almalıdır.",
      aboutText4: "İşte bu sebeple Profinoks Mutfak; Müşterilerin ihtiyacı olan ürünleri yüksek çeşitlilik ve kalite standartları ile müşterilerine sunmaktadır.",
      aboutText5: "Mutfak sektöründe faaliyet gösteren firmamız sizlerinde katılımı ile başta işleyiş, düzen ve sistem dahilinde kalite bilincini çalışanlarına ve müşterilerine yaşatmak için gerekli her türlü alt yapı oluşumunu sağlayarak çalışmalarına devam edecektir.",
      missionTitle: "MİSYON & VİZYON",
      missionSub: "MİSYONUMUZ",
      missionText: "PROFİNOKS MUTFAK olarak üstlenmiş olduğumuz misyon; faaliyet gösterdiğimiz sektörde standardı yüksek ürün ve kalite odaklı hizmet anlayışı ile projeler üretmeye devam etmektir. Bu doğrultuda hedefimiz, çevreye ve evrensel değerlere karşı sorumluluklarımızı yerine getirmek, gelişen Türkiye’yle beraber hedeflerimize doğru büyüyerek ilerlemektir.",
      visionSub: "VİZYONUMUZ",
      visionText: "Kuruluşumuzdan bugüne firmamız “Üstün Hizmet, Kesin Çözüm ve Güven” sloganı üzerine şekillenmiştir. Bu vizyonun bizim için anlamı sunduğumuz ürün ve hizmetlerle piyasada bize duyulan güveni her gün hak etmek ve müşteri memnuniyetini sağlayarak daha ileri seviyelere taşımaktır.",
      qualityTitle: "KALİTE POLİTİKAMIZ",
      qualitySubtitle: "Kalite Politikalarımız;",
      qualityIntro: "Profinoks Mutfak olarak en önemli ürünümüz KALİTE ‘dir. Kalite sürdürülebilir ve geliştirilebilir bir hizmet olduğunda anlam kazanır. Firmamızın sürdürülebilir kalite standartları ile çözüm odaklı projeler sunmaya devam edecektir.",
      qualityItems: [
        "KALİTE firmamızın kültürüdür. O ‘nu sürekli geliştireceğiz.",
        "Müşteri isteklerini mümkün olan en kısa zamanda ve en iyi şekilde hazırlayacağız.",
        "Hedeflerimiz doğrultusunda karşılaştığımız problemleri çözmenin yanında, problemin kaynağını araştırıp tekrarını önlemektir.",
        "Çalışanlarımız için eğitim programları düzenleyerek tüm aşamalarda gelişimi birincil koşul olarak gerçekleştireceğiz.",
        "Uluslararası standartlara uygun olarak imalatını yapmış olduğumuz mutfak ekipmanları ve aksesuar çeşitleri ile sizlere her zaman doğru olanı sağlayacağız."
      ]
    },
    contact: {
      heading: "İLETİŞİM",
      infoHeading: "İLETİŞİM BİLGİLERİ",
      formHeading: "BİZE ULAŞIN",
      address: "ADRES",
      phone: "TELEFON",
      email: "E-POSTA",
      hours: "ÇALIŞMA SAATLERİ",
      nameLabel: "ADINIZ",
      emailLabel: "E-POSTA",
      subjectLabel: "KONU",
      messageLabel: "MESAJINIZ",
      sendButton: "GÖNDER",
      sending: "GÖNDERİLİYOR...",
      successMsg: "Mesajınız başarıyla gönderildi!",
      errorMsg: "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
    },
  },
};

export function t(lang, path) {
  const segments = path.split(".");
  let node = translations[lang] || translations.en;
  for (const key of segments) {
    if (!node || typeof node !== "object") return path;
    node = node[key];
  }
  return node ?? path;
}
